import React, { useState } from 'react';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import { DropzoneArea } from 'material-ui-dropzone';
import { NotificationManager } from 'react-notifications';

import cloudUploadIcon from '../../../../../../images/icons/cloud-upload.svg';
import { signatureImageCreate } from '../../../../../../services/signatures.service';
import ButtonComponent from '../../../../../common-components/ButtonComponent/ButtonComponent';

export default function UploadContractSignature({ onClose, onUploadFinish, isInfluencerSigning }) {
  const [selectedFile, setSelectedFile] = useState(undefined);
  const [uploadedFileName, setUploadedFileName] = useState('');
  const [imgPreviewUrl, setImgPreviewUrl] = useState('');

  const [isLoading, setIsLoading] = useState(false);

  const onUpload = async () => {
    if (isInfluencerSigning) {
      onUploadFinish({
        type: 'image',
        src: imgPreviewUrl,
      });
      return;
    }

    setIsLoading(true);
    try {
      const res = await signatureImageCreate();
      const uploadUrl = res?.data?.imageUploadUrl;

      if (!uploadUrl) throw new Error('No upload url');

      await fetch(uploadUrl, {
        method: 'PUT',
        body: selectedFile,
      });

      onUploadFinish({
        type: 'image',
        src: res?.data?.imageGetUrl,
        _id: res?.data?._id,
      });
    } catch (error) {
      console.log('#wyz0180823 signature img upload failed');
    }

    setIsLoading(false);
  };

  return (
    <div>
      <div className="label-div">
        <p>
          Upload File <span>*</span>
        </p>
      </div>

      {selectedFile ? (
        <div className="img-preview-container">
          <div
            style={{ position: 'absolute', top: 6, right: 6, cursor: 'pointer' }}
            onClick={() => {
              setSelectedFile(undefined);
              setUploadedFileName('');
              setImgPreviewUrl('');
            }}>
            <CancelOutlinedIcon style={{ color: 'var(--critical-r-500)' }} />
          </div>

          <img src={imgPreviewUrl} alt="" style={{ width: '95%', height: 190, objectFit: 'contain' }} />
        </div>
      ) : (
        <div className="upload-input-container signature-input ">
          <DropzoneArea
            onChange={(files) => {
              const file = files[0];
              if (file) {
                const fileSize = (file.size / 1024) * 0.001;
                // check file size should be less than 5mb
                if (fileSize > 10) {
                  NotificationManager.error('Max size is 10mb', '', 1200);
                  return;
                }
                setUploadedFileName(file?.path);
                setSelectedFile(file);
                setImgPreviewUrl(URL.createObjectURL(file));
              }
            }}
            onDropRejected={(e) => {
              NotificationManager.error("That's not an image. Please import an image.", '', 1200);
            }}
            maxFileSize={1000000000}
            filesLimit={1}
            acceptedFiles={['.jpg', '.png']}
            showAlerts={false}
            style={{ backgroundColor: '#fff' }}
          />

          <div className="dropzone-text-container">
            <img src={cloudUploadIcon} alt="" />
            <p className="first-text">Drop your file here, or</p>
            <p className="blue-text">select from computer</p>
          </div>
        </div>
      )}

      <div className="sign-contract-buttons-container">
        <ButtonComponent onClick={onClose} variant="secondary">
          Cancel
        </ButtonComponent>

        <ButtonComponent
          disabled={!selectedFile}
          showLoading={isLoading}
          onClick={onUpload}
          type="submit"
          disabledStyle={{ fontSize: '16px' }}>
          Upload
        </ButtonComponent>
      </div>
    </div>
  );
}
